import styles from "./Footer.module.scss";
import { Link } from "react-router-dom";
import { FaGithub, FaTwitter, FaDiscord, FaLinkedin } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles["footer__wrapper"]}>
        <div className={styles["footer__content"]}>
          {/* Brand Section */}
          <div className={styles["footer__brand"]}>
            <h3>PLAYBOX</h3>
            <p>
              Build interfaces swiftly and effectively with no fuss. Customize
              and save components with zero setup required.
            </p>
            <div className={styles["footer__social"]}>
              <a href="#" aria-label="GitHub">
                <FaGithub />
              </a>
              <a href="#" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="#" aria-label="Discord">
                <FaDiscord />
              </a>
              <a href="#" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className={styles["footer__links"]}>
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/support">Support</Link>
              </li>
              <li>
                <Link to="/start-now">Dashboard</Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className={styles["footer__links"]}>
            <h4>Resources</h4>
            <ul>
              <li>
                <a href="#">Documentation</a>
              </li>
              <li>
                <a href="#">Tutorials</a>
              </li>
              <li>
                <a href="#">API Reference</a>
              </li>
              <li>
                <a href="#">Examples</a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className={styles["footer__links"]}>
            <h4>Support</h4>
            <ul>
              <li>
                <a href="#">Help Center</a>
              </li>
              <li>
                <a href="#">Community</a>
              </li>
              <li>
                <a href="#">Contact Us</a>
              </li>
              <li>
                <a href="#">Status</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className={styles["footer__bottom"]}>
          <div className={styles["footer__copyright"]}>
            <p>&copy; 2024 PLAYBOX. All rights reserved.</p>
          </div>
          <div className={styles["footer__legal"]}>
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
